import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import {
    fetchCarlineData,
    fetchCarlineDataAsync,
    fetchCarlineFiltersData,
    fetchCarlineFiltersDataAsync,
    setCarlineDataState, setCarlineFiltersDataState,
} from '../../actions/app/carlineData.actions'
import { getCarlineFiltersApiUrl, getCarlinesApiUrl } from '../../../constants/apiUrls'
import { ApiRequest } from '../../apiRequest'
import CarlineData from '../../../entities/CarlineData'
import CarlineFiltersData from '../../../entities/CarlineFiltersData'
import carlineDataSelector from '../../selectors/carlines/carlineDataSelector'
import { logger } from '../../../utils/dccLogger'

const mergeCarlineAndFilterData = (
  carlineData: CarlineData,
  carlineFiltersData: CarlineFiltersData,
): CarlineData => {
  const filterMap = new Map(
    carlineFiltersData.carlineGroups.flatMap((group) =>
      group.carlines?.map((carline) => [carline.id, carline.attributesSet]) || [],
    ),
  )

  const mergedCarlineGroups = carlineData.carlineGroups.map((group) => ({
    ...group,
    carlines: group.carlines?.map((carline) => ({
      ...carline,
      attributes: filterMap.get(carline.id) || {},
    })) || null,
  }))

  return { carlineGroups: mergedCarlineGroups }
}

const carlineDataMiddleware = (apiRequest: ApiRequest): Middleware => (store) => {

  return (next) => (action) => {
    next(action)
    const { dispatch, getState } = store

    if (isActionOf(fetchCarlineData, action)) {
      apiRequest(
        {
          options: {
            url: getCarlinesApiUrl(),
            method: 'GET',
          },
          asyncActions: fetchCarlineDataAsync,
          causedBy: action,
        },
        dispatch,
      )
    }

    if (isActionOf(fetchCarlineDataAsync.success, action)) {
        const carlineData = action.payload
        dispatch(setCarlineDataState(carlineData))
        if (carlineData?.carlineGroups?.length > 0) {
            dispatch(fetchCarlineFiltersData())
        }
    }

    if (isActionOf(fetchCarlineFiltersData, action)) {
      apiRequest(
        {
          options: {
            url: getCarlineFiltersApiUrl(),
            method: 'GET',
          },
          asyncActions: fetchCarlineFiltersDataAsync,
          causedBy: action,
        },
        dispatch,
      )
    }

      if (isActionOf(fetchCarlineFiltersDataAsync.success, action)) {
          const carlineFiltersData = action.payload
          const carlineData = carlineDataSelector(getState())

          const mergedData = mergeCarlineAndFilterData(carlineData, carlineFiltersData)
          dispatch(setCarlineFiltersDataState(carlineFiltersData))
          dispatch(setCarlineDataState(mergedData))
      }

      if (isActionOf(fetchCarlineFiltersDataAsync.failure, action)) {
          logger.log("FAILED TO FETCH CARLINE FILTERS")
      }
  }
}

export default carlineDataMiddleware
